import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  height: 100vh;
`;

export const Left = styled.div<{ isLoading: boolean }>`
  flex: 1;
  background-color: #fff29f;
  display: flex;
  gap: calc(var(--u) * 80);
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: var(--sp-20);
  position: relative;
  overflow: hidden;

  &::before,
  &::after {
    content: "";
    position: absolute;
    width: 104.5vw;
    height: 80vw;
    border-radius: 50%;
    background-color: #ffd90050;
    left: -50%;
    transform: translateX(-50%);
  }

  &::before {
    top: 0;
    transform: translateX(-50%) translateY(-50%);
  }

  &::after {
    bottom: 0;
    transform: translateX(-50%) translateY(50%);
  }
`;

export const Right = styled.div`
  flex: 1;
  background-color: rgba(255, 255, 255, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
`;

export const Logo = styled.img<{
  $selectedSession: string;
  $isLoading: boolean;
}>`
  width: ${(props) => (props.$isLoading ? "calc(var(--u) * 300)" : "calc(var(--u) * 150)")};
  height: ${(props) => (props.$isLoading ? "calc(var(--u) * 300)" : "calc(var(--u) * 150)")};
  opacity: ${(props) => (props.$isLoading ? 0 : 1)};
  z-index: 1;
  animation: ${(props) => (props.$isLoading ? "fadeIn" : "none")} 2s linear
    forwards;
  animation-delay: 1s;
`;

export const WelcomeText = styled.div`
  z-index: 1;
  color: #ffc400;
  font-size: 4em;
  font-weight: bolder;
  text-align: center;
  opacity: 0;
  animation: fadeIn 1s forwards;
`;

export const DescriptionText = styled.div`
  position: absolute;
  bottom: calc(var(--u) * 20);
  z-index: 1;
  color: #aea04a;
  font-size: var(--fs-base);
`;

export const ModalContent = styled.div`
  background-color: rgba(255, 255, 255, 0.8);
  padding: var(--sp-20);
  border-radius: 10px;
  width: 70%;
`;

export const Input = styled.input`
  width: 100%;
  padding: var(--sp-10);
  box-sizing: border-box;
  border: 1px solid #ccc;
  border-radius: 4px;
  transition: border-color 0.3s;

  &:hover {
    border-color: #007bff;
  }
`;

export const TextInput = styled.div`
  margin: var(--sp-20) 0;
  width: 100%;
  font-size: var(--fs-base);
  position: relative;
  border: 1px solid ${({ theme }) => theme.colors.selection};
  border-radius: 6px;
  margin-right: var(--sp-10);

  display: flex;
  align-items: center;

  input {
    width: 100%;
    padding: var(--sp-4) var(--sp-2) var(--sp-2) var(--sp-4);
    height: calc(var(--u) * 50);

    border: 1px solid #bbbbbb;
    border-radius: 5px;
    transition: outline 0.2s ease;
  }
  input:focus {
    box-shadow: 0 0 0 1px #e8e8e8,
      0 0 0 3px ${({ theme }) => theme.colors.selection};
  }

  label {
    width: fit-content;
    padding: 0 var(--sp-5);
    transition: all 0.1s ease-in-out;
    position: absolute;
    top: -30%;
    left: calc(var(--u) * 20);
    /* transform: translateY(-50%); */
    pointer-events: none;
    background: #ffffff;
    border-radius: 5px;
    color: white;
    background-color: ${({ theme }) => theme.colors.selection};
  }
`;

export const IconLabel = styled.span`
  font-family: "Material Icons";
  font-size: var(--fs-3xl);
  color: #ffc400;
  margin-right: var(--sp-10);
`;

export const IconInput = styled.span`
  font-family: "Material Icons" !important;
  font-size: var(--fs-2xl);
  margin-right: var(--sp-10);
`;

export const ForgotPasswordLink = styled.a`
  display: block;
  margin-top: var(--sp-5);
  text-align: right;
  text-decoration: none;
  color: #007bff;

  &:hover {
    text-decoration: underline;
  }
`;

export const ButtonWrapper = styled.div`
  display: flex;
  width: 100%;
  gap: var(--sp-16);
`;

export const Button = styled.button`
  position: relative;
  width: 100%;
  height: calc(var(--u) * 50);
  margin-top: var(--sp-20);
  margin-bottom: var(--sp-20);
  border-radius: 6px;
  background-color: #ffe460;
  color: black;
  font-size: var(--fs-xl);
  font-weight: bold;
  cursor: pointer;
  &:hover {
    color: white;
    background-color: #ffc303;
  }
`;

/**
 * O botão "Ver a demonstração", que só é RENDERIZADO com `REACT_APP_DEMO=sim`
 * (ver LoginModal.tsx). Deliberadamente SECUNDÁRIO em relação ao `Button`
 * amarelo do "Entrar": num build de demonstração ele é o caminho principal, mas
 * o componente é o mesmo do login de verdade e a hierarquia visual não pode
 * sugerir que "entrar" é o caminho errado.
 */
export const DemoButton = styled.button`
  position: relative;
  width: 100%;
  height: calc(var(--u) * 44);
  margin-bottom: var(--sp-16);
  border-radius: 6px;
  background-color: transparent;
  border: 2px solid #26792f;
  color: #26792f;
  font-size: var(--fs-lg);
  font-weight: bold;
  cursor: pointer;
  transition: 0.2s;
  &:hover {
    background-color: #26792f;
    color: white;
  }
  &:disabled {
    opacity: 0.6;
    cursor: default;
  }
`;

export const DemoHint = styled.div`
  width: 100%;
  text-align: center;
  color: rgba(0, 0, 0, 0.55);
  font-size: var(--fs-xs);
  margin-bottom: var(--sp-8);
`;

export const PasswordWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
`;

export const TogglePasswordButton = styled.button`
  position: absolute;
  width: fit-content;
  right: 0%;
  background: none;
  border: none;
  cursor: pointer;
  color: #007bff;
  display: flex;
`;

export const SignUp = styled.div`
  position: absolute;
  top: calc(var(--u) * 30);
  right: calc(var(--u) * 20);
  justify-content: flex-start;
  display: flex;
  align-items: center;
`;

export const SignUpText = styled.span`
  color: rgba(0, 0, 0, 0.5);
  margin-right: var(--sp-10);
`;

export const SignUpButton = styled.button`
  background: transparent;
  border: 2px solid rgba(0, 0, 0, 0.5);
  border-radius: 15px;
  padding: var(--sp-8) var(--sp-10);
  cursor: pointer;
  transition: 0.3s;
  color: rgba(0, 0, 0, 0.5);
  font-size: var(--fs-xs);
  display: inline-flex;
  align-items: center;

  .material-icon {
    font-family: "Material Icons";
    font-size: var(--fs-2xl);
    margin-right: var(--sp-2);
  }

  &:hover {
    color: rgba(0, 0, 0, 0.5);
    background: rgba(255, 196, 0, 0.372);
  }
`;
